import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import SpeedsplitLogo from './ui/SpeedsplitLogo';
import { usePwaInstall } from '../PwaInstallContext';


const UPI_ID = '9661663399@ybl';
const UPI_NAME = 'Kanaihya Kumar';
const UPI_QR_VALUE = `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(UPI_NAME)}&cu=INR`;

const Footer = () => {
  
  const currentYear = new Date().getFullYear();
  const [showQR, setShowQR] = useState(false);
  const [qrAnim, setQrAnim] = useState('enter');
  const { canPromptInstall, install } = usePwaInstall();

  const toggleQR = () => {
    if (!showQR) {
      setQrAnim('enter');
      setShowQR(true);
    } else {
      setQrAnim('exit');
      setTimeout(() => setShowQR(false), 380);
    }
  };

  return (
    <footer className="app-footer">
      <div className="container">
        <div className="footer-content">
          <div className="row">
            <div className="col-md-3 mb-3 mb-md-0">
              <h2 className="footer-title">Speedsplit</h2>
              <p className="footer-text">
                A simple yet powerful tool to manage and split expenses among friends, roommates, or any group.
              </p>
            </div>
            
            <div className="col-md-3 mb-3 mb-md-0">
              <h2 className="footer-title">Quick Links</h2>
              <nav aria-label="Footer navigation">
                <ul className="footer-links">
                  <li><Link to={'/'}>Home</Link></li>
                  <li><Link to={'/help'}>Help &amp; Guide</Link></li>
                  <li><Link to={'/about-us'}>About Us</Link></li>
                  <li><Link to={'/contact-us'}>Contact Us</Link></li>
                  <li><Link to={'/terms-of-service'}>Terms of Service</Link></li>
                  <li><Link to={'/privacy-policy'}>Privacy Policy</Link></li>
                  {canPromptInstall ? (
                    <li>
                      <button
                        type="button"
                        className="footer-pwa-install"
                        onClick={() => install()}
                        aria-label="Install app — add Speedsplit to your device"
                      >
                        <i className="bi bi-download" aria-hidden="true" />
                        <span>Install app</span>
                      </button>
                    </li>
                  ) : null}
                </ul>
              </nav>
            </div>
            
            <div className="col-md-3 mb-3 mb-md-0">
              <h2 className="footer-title">Connect</h2>
              <div className="social-icons justify-content-center">
                <a href="https://www.instagram.com/kanaihyakumar/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Follow on Instagram">
                  <i className="bi bi-instagram" aria-hidden="true"></i>
                </a>
                <a href="https://www.linkedin.com/in/kanaihya-kumar/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Connect on LinkedIn">
                  <i className="bi bi-linkedin" aria-hidden="true"></i>
                </a>
              </div>
            </div>

            <div className="col-md-3 mb-3 mb-md-0">
              <h2 className="footer-title">Support Us ☕</h2>
              <p className="footer-text" style={{ fontSize: '0.85rem' }}>
                If Speedsplit saved you time, consider buying me a coffee!
              </p>
              <div className="upi-support-box">
                <span className="upi-label">Pay via UPI</span>

                <button
                  className="upi-qr-toggle-btn"
                  onClick={toggleQR}
                  aria-expanded={showQR}
                >
                  {showQR
                    ? <><i className="bi bi-eye-slash"></i> Hide QR</>
                    : <><i className="bi bi-qr-code"></i> Show QR</>
                  }
                </button>

                {showQR && (
                  <div className={`upi-qr-wrapper upi-qr-${qrAnim}`}>
                    <div className="upi-qr-glow-ring">
                      <div className="upi-qr-card">
                        <QRCodeSVG
                          value={UPI_QR_VALUE}
                          size={150}
                          bgColor="transparent"
                          fgColor="#433878"
                          level="H"
                          imageSettings={{
                            src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ctext y='.9em' font-size='90'%3E☕%3C/text%3E%3C/svg%3E",
                            height: 28,
                            width: 28,
                            excavate: true,
                          }}
                        />
                        <p className="upi-qr-hint">Scan with any UPI app</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          <div className="footer-divider"></div>
          
          <div className="footer-bottom">
            <Link to={'/'} className="footer-brand">
              <SpeedsplitLogo height={28} />
            </Link>
            <p className="copyright">&copy; {currentYear} Speedsplit. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;